import React from 'react';

const GoogleCalender = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M13.034 22.644c-.63-.425-1.066-1.046-1.304-1.867l1.461-.602c.133.505.365.896.695 1.174.329.278.729.415 1.196.415.478 0 .888-.145 1.232-.436.343-.29.515-.66.515-1.11 0-.458-.18-.833-.543-1.123-.362-.29-.817-.436-1.36-.436h-.844v-1.446h.758c.467 0 .861-.127 1.181-.38.32-.252.48-.597.48-1.037 0-.392-.143-.703-.43-.937-.286-.234-.648-.352-1.088-.352-.43 0-.77.114-1.023.344-.253.23-.436.511-.552.844l-1.446-.602c.192-.544.543-1.024 1.059-1.438.516-.415 1.175-.623 1.975-.623.591 0 1.124.113 1.595.343.472.23.843.547 1.11.951.267.407.4.861.4 1.367 0 .515-.124.951-.373 1.31a2.568 2.568 0 0 1-.915.822v.087c.478.2.867.505 1.174.915.306.41.46.901.46 1.474s-.146 1.084-.436 1.533c-.291.448-.693.802-1.203 1.059a3.79 3.79 0 0 1-1.724.387 3.57 3.57 0 0 1-2.05-.636Zm8.974-7.25-1.604 1.16-.802-1.217 2.878-2.076h1.103v9.792h-1.575v-7.66Z"
            fill="#0085F7"
        />
        <path
            d="M26.421 26.421H9.58l-2.41 3.553L9.578 34h16.842l1.992-4.284-1.992-3.295Z"
            fill="#00A94B"
        />
        <path
            d="M26.421 2H4.526A2.526 2.526 0 0 0 2 4.526v21.895l3.79 2.694 3.789-2.694V9.58h16.842l2.593-3.79L26.42 2Z"
            fill="#0085F7"
        />
        <path
            d="M2 26.421v5.053A2.526 2.526 0 0 0 4.526 34H9.58v-7.579H2Z"
            fill="#00802E"
        />
        <path
            d="M34 9.579 30.21 7.14l-3.789 2.438V26.42l3.408 1.779L34 26.421V9.58Z"
            fill="#FFBC00"
        />
        <path
            d="M34 9.579V4.526A2.526 2.526 0 0 0 31.474 2H26.42v7.579H34Z"
            fill="#0067D5"
        />
        <path d="M26.421 34 34 26.421h-7.579v7.58Z" fill="#FF4131" />
    </svg>
);

export default GoogleCalender;